import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import "./dropdown.scss";
import {DropDownItem} from "../../modals/types/dropdown";

interface IDropDown {
    items: DropDownItem[]
    placeHolder: string
    setValue?: React.Dispatch<React.SetStateAction<DropDownItem>>
    value?: DropDownItem
}

export default function DropDown({items, placeHolder, value, setValue}: IDropDown) {
    return (
        <div className="Drop-Down">
            <Autocomplete
                onChange={(_event, value) => setValue ? setValue(value ? value : {label: ""}) : ""}
                disablePortal
                id="combo-box-demo"
                options={items}
                value={value}
                renderInput={(params) => <TextField {...params} label={placeHolder}/>}
            />
        </div>
    );
}
